import {
  FALLBACK_LABELS,
  MINIMUM_INPUTS,
  SOMATIC_OPTIONS,
} from "@/components/aposEngine/knowledgeBank";

FALLBACK_LABELS.minimum = "Lowest-demand state-matched option";

if (SOMATIC_OPTIONS["organize-high-activation"]) {
  SOMATIC_OPTIONS["organize-high-activation"] = {
    ...SOMATIC_OPTIONS["organize-high-activation"],
    title: "Somatic downshift with movement",
    instruction:
      "Orient to the space around you, release unnecessary shoulder and jaw tension, complete gentle shoulder, trunk, and hip movement, then finish with an easy two-minute walk or seated rhythmic movement.",
  };
}

if (SOMATIC_OPTIONS["organize-overwhelm"]) {
  SOMATIC_OPTIONS["organize-overwhelm"] = {
    ...SOMATIC_OPTIONS["organize-overwhelm"],
    title: "Orient and move slowly",
    instruction:
      "Reduce one source of unnecessary stimulation, orient to the room, and complete gentle repetitive movement at a pace you can easily stop or change.",
  };
}

MINIMUM_INPUTS["organize-high-activation"] =
  "Release unnecessary tension, change rooms or step outside briefly when practical, and check whether the pressure to react changes before choosing the next input.";
MINIMUM_INPUTS["organize-overwhelm"] =
  "Reduce one source of stimulation, orient to the space around you, and make one simple change that lowers the immediate demand.";

export const APOS_INTERVENTION_SEQUENCE_RULE =
  "Preparation, main input, transition, and recovery must have distinct jobs. Do not repeat the same regulatory modality in adjacent stages unless its purpose materially changes.";
